import React from 'react';
import styled from 'styled-components';
import { Heading, Logo, palette, spacing, Container } from '@landr/maestro';
import { Trans, Plural } from '@lingui/macro';
import Artworks from 'components/Artworks/Artworks';
import DescriptiveSection from '../DescriptiveSection/DescriptiveSection';
import OneCreditOneSample from '../OneCreditOneSample/OneCreditOneSample';

export const CreditsStyled = styled.span`
    color: ${palette('primary.500')};
`;

export const ArtworksWrapper = styled(Container)`
    margin-bottom: ${spacing('jb')};
    width: 100%;

    ${({ theme }): string => theme.breakpoint('md')`
        margin: 0;
        margin-bottom: ${spacing('xxl')}
    `};
`;

const PremiumHeader = ({ creditsNeeded }: { creditsNeeded?: number }) => (
    <Plural
        value={creditsNeeded}
        one={
            <Trans>
                Subscribe to get this sample{' '}
                <CreditsStyled>without spending credits</CreditsStyled>
            </Trans>
        }
        other={
            <Trans>
                Subscribe to get these samples{' '}
                <CreditsStyled>without spending credits</CreditsStyled>
            </Trans>
        }
    />
);

const CreditsHeader = ({ creditsNeeded }: { creditsNeeded?: number }) => (
    <Plural
        value={creditsNeeded}
        one={
            <Trans>
                You are missing{' '}
                <CreditsStyled>
                    {/* \u00A0 is a non breaking-space &nbsp; but we have to use unicode so that lingui keep the non-breaking space char */}
                    {`${creditsNeeded}\u00A0credit`}
                </CreditsStyled>{' '}
                to download this sample
            </Trans>
        }
        other={
            <Trans>
                You are missing{' '}
                <CreditsStyled>
                    {/* \u00A0 is a non breaking-space &nbsp; but we have to use unicode so that lingui keep the non-breaking space char */}
                    {`${creditsNeeded}\u00A0credits`}
                </CreditsStyled>{' '}
                to download these samples
            </Trans>
        }
    />
);

export const DescriptivePaidUpsell = ({
    artUrl,
    creditsNeeded,
    isPremium,
}: {
    artUrl?: string;
    creditsNeeded?: number;
    isPremium: boolean;
}) => {
    return (
        <>
            <DescriptiveSection>
                {artUrl ? (
                    <ArtworksWrapper size="xs">
                        <Artworks
                            artworks={[
                                {
                                    isExclusive: false,
                                    artworkUrl: artUrl,
                                },
                            ]}
                        />
                    </ArtworksWrapper>
                ) : (
                    <Logo variant="brand" color="neutral.50" mb="xxl" />
                )}
                <Heading as="h2">
                    {isPremium && (
                        <PremiumHeader creditsNeeded={creditsNeeded} />
                    )}
                    {!isPremium && (
                        <CreditsHeader creditsNeeded={creditsNeeded} />
                    )}
                </Heading>
                <OneCreditOneSample />
            </DescriptiveSection>
        </>
    );
};

export default DescriptivePaidUpsell;
